export const scrollTop = () => window.scrollTo(0, 0);

export const formatViewNumber = (number) => {
  return number.toFixed(2).replace('.', ',');
};
